<!-- 工作台 -->
<template>
    <div v-loading="loading">
        <div class="form-main cus-infoes">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" class="formData">
                <div class="formData-img" v-if="source == 1 && formData.PictureList.length != 0">
                    <ul class="el-upload-list el-upload-list--picture" style="width: 100%; display: flex; max-height: 200px">
                        <li
                            v-for="(item, index) in formData.PictureList"
                            :tabindex="index"
                            :key="index"
                            class="el-upload-list__item is-success"
                            style="width: 100px; height: 100px; margin-right: 5px"
                        >
                            <el-tooltip v-if="item.FileName.indexOf('.doc' || '.docx') > -1" effect="dark" :content="item.FileName" placement="top">
                                <img class="el-upload-list__item-thumbnail" src="../../../assets/images/word-ext.png" @click="downLoadFile(item)" />
                            </el-tooltip>
                            <el-tooltip v-else-if="item.FileName.indexOf('.xls' || '.xlsx') > -1" effect="dark" :content="item.FileName" placement="top">
                                <img class="el-upload-list__item-thumbnail" src="../../../assets/images/excel-ext.png" @click="downLoadFile(item)" />
                            </el-tooltip>
                            <el-tooltip v-else-if="item.FileName.indexOf('.pdf') > -1" effect="dark" :content="item.FileName" placement="top">
                                <img class="el-upload-list__item-thumbnail" src="../../../assets/images/pdf-ext.png" @click="downLoadFile(item)" />
                            </el-tooltip>
                            <img
                                v-else
                                :src="download_url + item.FileUrl + '?imageView2/2/w/200'"
                                class="el-upload-list__item-thumbnail"
                                alt=""
                                @click="onPreview(item)"
                            />
                            <a v-if="type != 3" class="el-upload-list__item-name">
                                <i class="el-icon-document"></i>
                            </a>
                            <label v-if="type != 3" class="el-upload-list__item-status-label">
                                <i class="el-icon-upload-success el-icon-check"></i>
                            </label>
                            <i v-if="type != 3" class="el-icon-close" @click="handleMinorRemove(item, index)"></i>
                        </li>
                    </ul>
                </div>
                <div class="formData-top">
                    <div class="form-left form-column">
                        <el-form-item label="标签类型" prop="Tags">
                            <el-select size="small" filterable clearable allow-create v-model="formData.Tags" :disabled="isReadOnly">
                                <el-option v-for="optionItem in tagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户名称" prop="Name" v-if="source == 1">
                            <el-input size="small" v-model="formData.Name" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商名称" prop="Name" v-else>
                            <el-input size="small" v-model="formData.Name" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="客户来源" v-if="source == 1">
                            <el-select size="small" filterable clearable allow-create v-model="formData.Source" :disabled="isReadOnly" style="width: 70%">
                                <el-option v-for="optionItem in sourceList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                            <el-button icon="el-icon-edit" type="text" style="margin-left: 5px" @click="showSourceDialog" v-if="!isReadOnly">编辑</el-button>
                        </el-form-item>
                        <el-form-item label="简称" v-else>
                            <el-input size="small" v-model="formData.Abbr" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="CallNum">
                            <el-input size="small" v-model="formData.CallNum" :maxlength="20" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="价格等级">
                            <el-select size="small" filterable clearable v-model="formData.LevelId" :disabled="isReadOnly">
                                <el-option
                                    v-for="optionItem in levelList"
                                    :key="optionItem.LevelId"
                                    :label="optionItem.LevelName"
                                    :value="optionItem.LevelId"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="form-center form-column">
                        <el-form-item label="微信">
                            <el-input size="small" v-model="formData.WeChat" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="社媒号">
                            <el-input size="small" v-model="formData.Payment" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮箱">
                            <!-- prop="Email" -->
                            <el-input size="small" v-model="formData.Email" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="QQ">
                            <el-input size="small" v-model="formData.Qq" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="网址">
                            <el-input size="small" v-model="formData.Website" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-right form-column">
                        <!-- 主营配件名称，主营适用车型 必填 by qdl 2020/4/7 -->
                        <el-form-item label="主营配件" prop="MainPartName">
                            <el-input size="small" v-model="formData.MainPartName" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="主营车型" prop="MainVehicle">
                            <el-input size="small" v-model="formData.MainVehicle" placeholder="格式：品牌 + 车系" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="其他联系人">
                            <el-input size="small" v-model="formData.Contactor" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人电话" prop="PhoneNum">
                            <el-input size="small" v-model="formData.PhoneNum" :maxlength="20" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="职位">
                            <el-input size="small" v-model="formData.Position" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="formData-bottom">
                    <div>
                        <el-form-item label="国家" prop="CountryId">
                            <el-select
                                size="small"
                                v-model="formData.Country"
                                style="width: 186px"
                                filterable
                                clearable
                                value-key="CountryName"
                                @change="countryChange"
                                placeholder="请选择"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in countryList" :key="item.CountryId" :label="item.CountryName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="省市区">
                            <el-select
                                size="small"
                                v-model="formData.Province"
                                style="width: 164px"
                                filterable
                                clearable
                                value-key="ProvinceName"
                                @change="provinceChange"
                                placeholder="请选择省"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in provinceList" :key="item.ProvinceId" :label="item.ProvinceName" :value="item"></el-option>
                            </el-select>
                            <el-select
                                size="small"
                                v-model="formData.City"
                                style="width: 164px"
                                filterable
                                clearable
                                value-key="CityName"
                                @change="cityChange"
                                placeholder="请选择市"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in cityList" :key="item.CityId" :label="item.CityName" :value="item"></el-option>
                            </el-select>
                            <el-select
                                size="small"
                                v-model="formData.Zone"
                                style="width: 164px"
                                filterable
                                clearable
                                value-key="DistrictName"
                                @change="zoneChange"
                                placeholder="请选择区"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in zoneList" :key="item.DistrictId" :label="item.DistrictName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="formData-bottom">
                    <el-form-item label="详细地址">
                        <el-input size="small" v-model="formData.Address" style="width: 493px" maxlength="180" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <img src="../../../assets/images/add.png" class="addicon" @click="addAddress()" title="添加地址" v-if="source == 1 && !isReadOnly" />
                    <el-form-item label="区号" label-width="64px">
                        <div class="form-value" style="width: 96px">
                            {{ formData.ZoneNum }}
                        </div>
                    </el-form-item>
                    <el-form-item label="邮编" label-width="54px">
                        <el-input style="width: 96px" size="small" v-model="formData.Zipcode" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                </div>
                <div class="formData-bottom" v-if="showSecAddr && source == 1">
                    <el-form-item label="地址2">
                        <el-input size="small" v-model="formData.Address2" style="width: 493px" maxlength="150" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <img src="../../../assets/images/del.png" class="addicon" @click="delAddress(2)" v-if="!isReadOnly" />
                </div>
                <div class="formData-bottom" v-if="showThirdAddr && source == 1">
                    <el-form-item label="地址3">
                        <el-input size="small" v-model="formData.Address3" style="width: 493px" maxlength="150" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <img src="../../../assets/images/del.png" class="addicon" @click="delAddress(3)" v-if="!isReadOnly" />
                </div>
                <div class="formData-bottom">
                    <el-form-item label="备注">
                        <el-input size="small" v-model="formData.Infoes" style="width: 400px" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <el-form-item :label="source == 1 ? '跟进业务员' : '跟进采购员'">
                        <el-select size="small" v-model="formData.FollowerId" class="search-item" filterable placeholder="请选择" clearable :disabled="isReadOnly">
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="自采推荐" v-if="source == 2">
                        <el-switch v-model="formData.IsRecommend" active-color="#13ce66" :disabled="isReadOnly" inactive-color="#ff4949"> </el-switch>
                    </el-form-item>
                </div>
                <div class="formData-bottom" v-if="source == 1">
                    <div class="form-left form-column">
                        <el-form-item label="物流公司" prop="">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="formData.LogisticId"
                                placeholder="请输入物流公司"
                                filterable
                                clearable
                                :disabled="isReadOnly"
                                remote
                                @visible-change="logisticVisibleChange($event)"
                                :remote-method="searchLogistic"
                                v-select-scroll-more="searchLcLoad"
                                @clear="clearLogistic"
                            >
                                <el-option v-for="item in lcOptions" :key="item.EntpCusId" :data-msg="item" :label="item.EntpCusName" :value="item.EntpCusId">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span class="phone" v-if="item.Phone">
                                            {{ ' ( 电话：' + item.Phone + ' )' }}
                                        </span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="form-center form-column">
                        <el-form-item label="支付方式" prop="PayType">
                            <el-select size="small" v-model="formData.PayType" :disabled="isReadOnly" placeholder="请选择" clearable filterable style="width: 100%">
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="form-right form-column">
                        <el-form-item label="挂账限额" prop="MaxCreditMoney">
                            <el-input-number
                                style="width: 100%"
                                controls-position="right"
                                size="small"
                                :precision="2"
                                :min="0"
                                :step="0.1"
                                :disabled="isReadOnly"
                                v-model.trim="formData.MaxCreditMoney"
                            ></el-input-number>
                        </el-form-item>
                    </div>
                </div>
                <div class="formData-bottom" v-if="type == 1 || type == 2 || source == 1">
                    <el-form-item style="height: 110px" label="智能填写" v-if="type == 1 || type == 2">
                        <el-input
                            size="small"
                            v-model="smContent"
                            type="textarea"
                            style="width: 507px"
                            :rows="5"
                            placeholder="比如：广东省珠海市香洲区盘山路28号幸福茶庄,陈景勇，13593464918"
                        ></el-input>
                    </el-form-item>
                    <div class="form-right form-column" v-if="source == 1">
                        <el-form-item label="限期模式" prop="CreditType">
                            <el-select size="small" v-model="formData.CreditType" :disabled="isReadOnly" placeholder="请选择限期模式">
                                <el-option label="结算周期" value="0"></el-option>
                                <el-option label="固定日期" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="formData.CreditType == '0'" label="结算周期" prop="CreditDay">
                            <el-input-number
                                controls-position="right"
                                size="small"
                                :min="0"
                                :step="1"
                                :max="365"
                                :disabled="isReadOnly"
                                v-model.trim="formData.CreditDay"
                            >
                            </el-input-number>
                            &nbsp;天
                        </el-form-item>
                        <el-form-item v-if="formData.CreditType == '1'" label="结账日期" prop="CreditDay">
                            <el-input-number controls-position="right" size="small" :min="0" :max="31" :step="1" :disabled="isReadOnly" v-model.trim="formData.CreditDay">
                            </el-input-number>
                            &nbsp;号
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <div class="dialog-footer" v-if="!isReadOnly">
                <div class="upload" v-if="source == 1">
                    <uploadFile
                        ref="uploadMinorFile"
                        type="EntpCusId"
                        :multiple="true"
                        :initfileList="formData.PictureList"
                        @uploadSuccess="uploadMinorSuccess"
                        @handleRemove="handleMinorRemove"
                    ></uploadFile>
                </div>
                <el-button class="search-btn" size="small" type="warning" v-if="type == 1 || type == 2" @click="smAddress">地址智能识别</el-button>
                <el-button class="btn-primary" size="small" @click="submitForm">提交保存</el-button>
                <el-button size="small" @click="cancel()">取消</el-button>
            </div>
        </div>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="previewList" :z-index="99999" :initial-index="initialIndex" />
        <customerSource v-if="sourceVisible" :dialogFormVisible="sourceVisible" @closeSourceDialog="closeSourceDialog"></customerSource>
    </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import customerSource from '@/components/business/customerManage/customerSource';
import uploadFile from '@/components/common/uploadFileAndImgBtn';
export default {
    props: ['type', 'cusId', 'source', 'fromPage'], // type 1 新增 2 编辑    source 1 客户 2 供应商   fromPage 1 客户列表
    components: {
        customerSource,
        uploadFile,
        ElImageViewer
    },
    name: '',
    data() {
        let checkPhone = this.$util.checkPhone;
        let checkEmail = this.$util.checkEmail;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            loading: false,
            sourceVisible: false,
            isReadOnly: false,
            countryCode: '86',
            sourceList: [],
            countryList: [],
            provinceList: [],
            SIdList: [],
            cityList: [],
            zoneList: [],
            tagsList: [],
            logisticsList: [],
            levelList: [],
            showSecAddr: false,
            showThirdAddr: false,
            formData: {
                EntpCusId: this.type == 1 ? '' : this.cusId,
                Tags: '',
                Name: '',
                Abbr: '',
                Source: '',
                CallNum: '',
                Qq: '',
                WeChat: '',
                Payment: '',
                Email: '',
                Address: '',
                Address2: '',
                Address3: '',
                Zipcode: '',
                ZoneNum: '86',
                MainPartName: '',
                MainVehicle: '',
                Contactor: '',
                PhoneNum: '',
                Position: '',
                Infoes: '',
                Website: '',
                Country: {
                    CallCode: '86',
                    CountryId: '54416925-01EE-40A2-A536-DA142C06F5E8',
                    CountryName: '中国'
                },
                CountryId: '54416925-01EE-40A2-A536-DA142C06F5E8',
                Province: {},
                ProvinceId: '',
                City: {},
                CityId: '',
                Zone: {},
                ZoneId: '',
                FollowerId: '',
                LogisticId: '',
                LogisticName: '',
                PayType: '',
                MaxCreditMoney: 0,
                CreditDay: 0,
                CreditType: '0',
                LevelId: '',
                PictureList: [],
                IsRecommend: true
            },
            rules: {
                Name: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                CountryId: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                Tags: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                // MainPartName: [
                //   {
                //     required: true,
                //     message: "该项必填",
                //     trigger: "blur",
                //   },
                // ],
                // MainVehicle: [
                //   {
                //     required: true,
                //     message: "该项必填",
                //     trigger: "blur",
                //   },
                // ],
                CallNum: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                    // {validator:checkPhone, trigger: 'blur'},
                ],
                Email: [
                    {
                        validator: checkEmail,
                        trigger: 'blur'
                    }
                ],
                PhoneNum: [
                    // {validator:checkPhone, trigger: 'blur'},
                ]
            },
            // 用于物流公司列表，分页搜索
            lcOptions: [],
            lcForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            smContent: '',
            initialIndex: 0,
            previewList: [],
            showViewer: false,
            payWayList: [],
            download_url: this.$util.QN_URL_BASE
        };
    },
    mounted() {
        if (this.type == 3) this.isReadOnly = true;
        this.initPage();
    },
    methods: {
        async initPage() {
            this.loading = true;
            await this.searchTags();
            await this.getCountryList();
            await this.getSourceList();
            await this.getCusPriceLevels();
            if (this.source == 1) await this.getPay();
            await this.getSIdList();

            if (this.type == 1) await this.getProvinceList(this.formData.Country.CountryId);
            else this.getCustomer();

            this.loading = false;
        },
        async getCustomer() {
            let url = this.source == 1 ? '/api/EntpCustomers/GetEnterpriseCustomer' : '/api/EntpSuppliers/GetEnterpriseSupplier';
            let res = await this.$util
                .axiosGet({
                    url: url,
                    data: {
                        EntpCusId: this.cusId
                    }
                })
                .catch(() => {});
            let data = res.data;
            data.EntpCusId = this.cusId;

            let CountryId = this.formData.CountryId;
            let Country = this.formData.Country;

            this.formData = data;
            if (!this.formData.CountryId) {
                this.formData.CountryId = CountryId;
                this.formData.Country = Country;
            }

            if (data.LogisticId) {
                this.lcOptions.push({ EntpCusId: data.LogisticId, EntpCusName: data.LogisticName });
            }

            if (this.source == 1) {
                if (this.formData.Address2) this.showSecAddr = true;

                if (this.formData.Address3) this.showThirdAddr = true;
            }

            if (data.CountryId) {
                this.getProvinceList(data.CountryId);
            }

            if (data.ProvinceId) {
                this.getCityList(data.ProvinceId);
            }
            if (data.CityId) {
                this.getZoneList(data.CityId);
            }
        },
        // 提交表单
        submitForm() {
            let that = this;
            let url = '';
            if (that.source == 1) {
                url = '/api/EntpCustomers/SaveEnterpriseCustomer';
                if (that.formData.CreditDay < 0) {
                    that.$util.warningMsg('挂账限期不可小于0');
                    return;
                }
                if (that.formData.CreditDay > 28 && that.formData.CreditType == '1') {
                    that.$util.warningMsg('为了避免2月挂账限制异常，挂账日请勿大于28');
                    return;
                }
            } else url = '/api/EntpSuppliers/SaveEnterpriseSupplier';
            that.$refs.formData.validate(valid => {
                if (valid) {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: url,
                            data: that.formData,
                            hideLoading: true
                        })
                        .then(resp => {
                            if (resp.errcode == 0) {
                                if (that.type == 1) {
                                    that.$util.successMsg('添加成功');
                                } else {
                                    that.$util.successMsg('修改成功');
                                }
                                that.$emit('closeDialog', 'edit', that.formData.EntpCusId, that.formData.Name);
                            }
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                } else {
                    this.$util.errorMsg('校验不通过');
                    return false;
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        showSourceDialog() {
            this.sourceVisible = true;
        },
        closeSourceDialog() {
            this.getSourceList();
            this.sourceVisible = false;
        },
        countryChange(value) {
            this.formData.CountryId = value.CountryId;
            this.countryCode = value.CallCode;
            this.formData.ZoneNum = value.CallCode;
            this.formData.ProvinceId = '';
            this.formData.Province = {};
            this.formData.CityId = '';
            this.formData.City = {};
            this.formData.ZoneId = '';
            this.formData.Zone = {};
            this.cityList = [];
            this.zoneList = [];
            this.getProvinceList(value.CountryId);
        },
        provinceChange(value) {
            this.formData.ProvinceId = value.ProvinceId;
            this.formData.CityId = '';
            this.formData.City = {};
            this.formData.ZoneId = '';
            this.formData.Zone = {};
            this.getCityList(value.ProvinceId);
        },
        cityChange(value) {
            let _CallCode = value.CallCode ? parseInt(value.CallCode).toString() : '';
            this.formData.CityId = value.CityId;
            this.formData.ZoneNum = this.countryCode + _CallCode;
            this.formData.ZoneId = '';
            this.formData.Zone = {};
            this.getZoneList(value.CityId);
        },
        zoneChange(value) {
            this.formData.ZoneId = value.DistrictId;
            this.formData.Zone = value.DistrictName;
        },
        getSourceList() {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpCustomers/GetEnterpriseCustomerSources',
                        hideLoading: true
                    })
                    .then(res => {
                        this.sourceList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getCountryList() {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCountryList',
                        hideLoading: true
                    })
                    .then(res => {
                        this.countryList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getProvinceList(CountryId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetProvinceList',
                        data: {
                            CountryId: CountryId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.provinceList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getCityList(ProvinceId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCityList',
                        data: {
                            ProvinceId: ProvinceId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.cityList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getZoneList(CityId) {
            this.$util
                .axiosGet({
                    url: '/api/Region/GetDistrictList',
                    data: {
                        CityId: CityId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.zoneList = res.data;
                })
                .catch(() => {});
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
                //跟进人默认是当前账号
                let fo = data.find(f => f.EmployeeId == this.userMsg.EmployeeId);
                if (!fo) {
                    this.SIdList.unshift({ EmployeeId: this.userMsg.EmployeeId, EmployeeName: this.userMsg.EmployeeName, IsDismiss: false });
                    this.formData.FollowerId = this.userMsg.EmployeeId;
                }
            });
        },
        searchTags() {
            let url = this.source == 1 ? '/api/EntpCustomers/GetEnterpriseCustomerTagList' : '/api/EntpSuppliers/GetEnterpriseSupplierTagList';
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: url,
                        hideLoading: true
                    })
                    .then(res => {
                        this.tagsList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        addAddress() {
            let that = this;
            if (that.formData.Address) {
                if (that.showSecAddr && !that.showThirdAddr) {
                    if (that.formData.Address2) that.showThirdAddr = true;
                    else this.$util.errorMsg('请先填写【地址2】，再进行添加【地址3】');
                } else if (that.showSecAddr && that.showThirdAddr) this.$util.errorMsg('目前仅支持新增3个地址');
                else that.showSecAddr = true;
            } else this.$util.errorMsg('请先填写【详细地址】，再进行添加【地址2】');
        },
        delAddress(idx) {
            let that = this;
            switch (idx) {
                case 2:
                    that.showSecAddr = false;
                    that.formData.Address2 = '';
                    break;
                case 3:
                    that.showThirdAddr = false;
                    that.formData.Address3 = '';
                    break;
            }
        },
        logisticVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.lcOptions.length == 0) that.searchLogistic('');
            }
        },
        searchLogistic(key) {
            if (![undefined].includes(key)) {
                this.lcForm.Page = 1;
                this.lcForm.stopLoad = false;
                this.lcForm.key = key;
                this.lcOptions = [];
            }
            if (this.lcForm.stopLoad) return;
            this.$util
                .searchLogistic(this.lcForm.key, this.lcForm.Page, this.lcForm.Limit)
                .then(res => {
                    let data = res;
                    if (!data) return;
                    this.lcForm.stopLoad = data.length < this.lcForm.Limit;
                    this.lcOptions = [...this.lcOptions, ...data];
                })
                .catch(() => {});
        },
        // 客户名称列表，加载更多
        searchLcLoad() {
            this.lcForm.Page += 1;
            this.searchLogistic();
        },
        clearLogistic() {
            this.searchLogistic('');
        },
        smAddress() {
            let that = this;
            if (!that.smContent) return;

            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpCustomers/SMAddress',
                    data: {
                        address: that.smContent,
                        isAdd: that.type == 1 && that.source == 1
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode != 0) return;
                    let data = res.data;

                    if (data.Name) that.formData.Name = data.Name;
                    if (data.CallNum) that.formData.CallNum = data.CallNum;
                    if (data.Address) that.formData.Address = data.Address;
                    if (data.Zipcode) that.formData.Zipcode = data.Zipcode;

                    if (data.ProvinceId) {
                        that.formData.ProvinceId = data.ProvinceId;
                        that.formData.Province = data.Province;
                        that.getCityList(data.ProvinceId);

                        if (data.CityId) {
                            that.formData.CityId = data.CityId;
                            that.formData.City = data.City;
                            this.getZoneList(data.CityId);

                            if (data.ZoneId) {
                                that.formData.ZoneId = data.ZoneId;
                                that.formData.Zone = data.Zone;
                            }
                        }
                    }

                    if (data.IsExistCus && that.type == 1 && that.source == 1 && data.EntpCusId && that.fromPage != 1) {
                        let txt = '检测到客户资料已存在，是否直接使用已存在的客户资料？如使用，有地址时则注意核实发货地址';

                        if (that.cusId) {
                            txt = '检测到客户资料已存在！';
                        }

                        //放到最后，反正上面赋值完也没有问题
                        if (data.IsExistCus) {
                            that.$confirm(txt, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                                center: false
                            })
                                .then(() => {
                                    if (!that.cusId) that.$emit('closeDialog', 'used', data.EntpCusId, data.CusName);
                                })
                                .catch(() => {});
                        }
                    }

                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        getCusPriceLevels() {
            this.$util.getCusPriceLevels().then(data => {
                this.levelList = data;
            });
        },
        // 上传图片成功后执行
        uploadMinorSuccess(res) {
            this.formData.PictureList.push({
                FileUrl: res.fileUrl,
                FileName: res.fileName + '.' + res.fileExt
            });
        },
        // 删除图片
        handleMinorRemove(file, index) {
            // let fileUrl = file;
            // let _pictureList = this.formData.PictureList;
            // for (let i = 0; i < _pictureList.length; i++) {
            //     if (_pictureList[i] == fileUrl) {
            //         _pictureList.splice(i, 1);
            //     }
            // }
            this.formData.PictureList.splice(index, 1);
        },
        downLoadFile(file) {
            let url = this.download_url + file.FileUrl;
            const a = document.createElement('a');
            a.href = url;
            a.download = file.FileName; // 下载后文件名
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); // 点击下载
            document.body.removeChild(a); // 下载完成移除元素
        },
        // 关闭查看器
        closeViewer() {
            this.showViewer = false;
        },
        // 打开上传图片预览
        onPreview(file) {
            let arr = this.formData.PictureList.filter(
                x =>
                    !(
                        x.FileName.indexOf('.xls') > -1 ||
                        x.FileName.indexOf('.xlsx') > -1 ||
                        x.FileName.indexOf('.doc') > -1 ||
                        x.FileName.indexOf('.docx') > -1 ||
                        x.FileName.indexOf('.pdf') > -1
                    )
            );
            this.previewList = arr.map(item => this.download_url + item.FileUrl);

            //这里因为除去了文件类型的，需要重新定位在纯图片类型的集合位置
            this.initialIndex = this.previewList.indexOf(this.download_url + file.FileUrl);
            if (this.initialIndex == -1) this.initialIndex = 0;
            this.showViewer = true;
        }
    }
};
</script>
<style lang="less" scoped>
.formData-bottom {
    display: flex;
}
.form-value {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 32px;
    line-height: 32px;
    padding: 0 15px;
    width: 100%;
}
.form-column {
    width: 33.33%;
}
.form-column2 {
    width: 66.66%;
}
.formData-top {
    display: flex;
}
.dialog-footer {
    text-align: right;
}
.addicon {
    height: 22px;
    margin-left: 10px;
    margin-top: 5px;
}
.formData-img {
    margin-bottom: 20px;
    overflow: auto;
}
.upload {
    display: inline-block;
    margin-right: 6px;
}
</style>
<style lang="less">
.cus-infoes {
    .el-form-item {
        margin-bottom: 18px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
</style>
